import { useTranslation } from 'react-i18next';

import type { IDataCheck, IDataCheckGroup } from '../../../interfaces/checks';
import CheckItem from '../CheckItem/CheckItem';

import './DataChecklist.scss';

interface IDataChecklistProps {
  groups: IDataCheckGroup[];
  onCheckClick?: (check: IDataCheck) => void;
  className?: string;
}

const DataChecklist = ({ groups, onCheckClick, className }: IDataChecklistProps) => {
  const { t } = useTranslation();

  const rootClass = ['data-checklist', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {groups.map((group) => (
        <div key={group.id} className="data-checklist__group">
          <div className="data-checklist__group-header">
            <span className="data-checklist__group-title">
              {group.title ?? (group.titleKey ? t(group.titleKey, group.titleParams ?? {}) : '')}
            </span>
          </div>

          <div className="data-checklist__checks">
            {group.checks.map((check) => (
              <CheckItem
                key={check.id}
                done={check.done}
                required={check.required}
                label={t(check.labelKey, check.labelParams ?? {})}
                onClick={onCheckClick ? () => onCheckClick(check) : undefined}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DataChecklist;
